import React from 'react';
import { Card } from 'react-bootstrap';
import * as LuIcon from 'react-icons/lu';
import { FaCheckCircle } from 'react-icons/fa';

import { useTranslation } from '../../../translations';
import {
  StepErrorDto,
  StepErrorDtoLevelEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';

interface StageModalErrorsProps {
  errors: StepErrorDto[];
}

export const StageModalErrors: React.FC<StageModalErrorsProps> = ({
  errors,
}) => {
  const { t, tk } = useTranslation('projectLng');

  const getLevelPriority = (level: StepErrorDtoLevelEnum): number => {
    switch (level) {
      case StepErrorDtoLevelEnum.Error:
        return 1;
      case StepErrorDtoLevelEnum.Warning:
        return 2;
      default:
        return 4;
    }
  };

  const sortedErrors = [...errors].sort(
    (a, b) => getLevelPriority(a.level) - getLevelPriority(b.level),
  );

  return (
    <Card
      className={`stage-modal-card stage-modal-card-errors rounded-3 border-${errors.length > 0 ? 'danger' : 'success'}`}
    >
      <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2 text-dark">
        {t(tk.timeLine.requiresAttention)}
      </h6>
      <div className="d-flex flex-column gap-3">
        {errors.length === 0 ? (
          <div className={`d-flex align-items-start ms-2 text-success`}>
            <FaCheckCircle className="me-2 my-1" size={16} />
            {t(tk.timeLine.allClear)}
          </div>
        ) : (
          sortedErrors.map((item, index) => (
            <div
              key={index}
              className={`d-flex align-items-start ms-2 text-danger`}
            >
              <LuIcon.LuTriangleAlert className="me-2 my-1" size={16} />
              <span dangerouslySetInnerHTML={{ __html: item.message }} />
            </div>
          ))
        )}
      </div>
    </Card>
  );
};
